// Get the modal
var modal = document.getElementById("pdpDetailModal");

// Get the button that opens the modal
var pdpDetailBtn = document.getElementById("pdpDetailBtn");

// Get the <span> element that closes the modal
var pdpDetailModalClose = document.getElementsByClassName(
  "pdpDetailModal-close"
)[0];

// When the user clicks the button, open the modal
if (pdpDetailBtn && modal) {
  pdpDetailBtn.onclick = function () {
    modal.style.display = "flex";
  };
}

// When the user clicks on <span> (x), close the modal
if (pdpDetailModalClose && modal) {
  pdpDetailModalClose.onclick = function () {
    modal.style.display = "none";
  };
}

// When the user clicks anywhere outside of the modal, close it
if (modal) {
  window.onclick = function (event) {
    if (event.target == modal) {
      modal.style.display = "none";
    }
  };
}
